<template>
  <div
    class="accordion"
    :class="[
      $blockClass(blockClass, 'accordion'),
      { 'accordion--small': small },
      { 'accordion--dark-divider': background && !background.includes('white') },
    ]"
  >
    <accordion-item
      v-for="item in items"
      :key="item.id"
      :block-class="blockClass"
      :item="item"
      :small="small"
      :clean-richtext="cleanRichtext"
      @accordionToggle="accordionToggle"
    >
      <template #customContent>
        <responsive-image
          v-if="item.image && item.media_selection === 'image'"
          :class="background"
          :image="item.image"
          :lazyload="true"
          :min-max="`375-${item.image.width}`"
          ratio="4:3"
          sizes="60vw"
        />

        <responsive-video
          v-else-if="item.video && item.media_selection === 'video'"
          :padding="true"
          :ratio="ratio"
          :ratio-desktop="ratio"
          :video-src="item.video"
        />
      </template>
    </accordion-item>
  </div>
</template>

<script>

/**
 * Vue: Accordion (accordion)
 * -----------------------------------------------------------------------------
 * A reusable accordion snippet that displays collapsible content.
 *
 * @param {String} background - Background color to apply to image loading
 * state.
 * @param {String} blockClass - Additional class to attach to element classes.
 * @param {Boolean} cleanRichtext - Strip richtext elements from accordion
 * item descriptions.
 * @param {Array} items - Accordion items / blocks.
 * @param {Boolean} multiOpen - If set to false, only one accordion can be
 * @param {Boolean} small - Use small styling for accordion.
 */
import AccordionItem from '~async/accordion/accordion-item'

export default {
  name: 'Accordion',

  components: {
    AccordionItem,
  },

  props: {
    background: {
      type: String,
      default: '',
    },
    blockClass: {
      type: String,
      default: '',
    },
    cleanRichtext: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    multiOpen: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['accordionToggle'],

  data() {
    return {
      ratio: '4:3',
    }
  },

  mounted() {
  },

  methods: {

    /**
     * Send event to parent if accordion item has been toggled.
     * Handles closing all accordions if multi open is not set.
     * @param {Object} payload - The accordion item that was toggled.
     */
    accordionToggle(payload = {}) {
      this.$emit('accordionToggle', payload)

      if (this.multiOpen || !payload.active) {
        return
      }

      this.items.forEach(item => {
        if (payload.id !== item.id) {
          item.active = false
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import './accordion';
</style>
